<template>
  <v-container>
    <v-row justify="center">
      <v-dialog v-model="dialog" v-show="showDialog" @click:outside="closeDialog" persistent max-width="1250px">
        <v-card v-if="product">
          <v-form ref="form" lazy-validation @input="formToggled">
            <v-card-title class="subtitle-1 grey accent" primary-title>
              <span class="text-h5">Update WholeSale Product</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col>
                    <TreeSelect v-model="product.CategoryId" style="padding-top: 0px; margin-top: 0px; width: 100%"
                      :dropdown-style="{
                        maxHeight: '400px',
                        overflow: 'auto',
                      }" :tree-data="categories" :replaceFields="{
                        children: 'children',
                        title: 'name',
                        key: 'id',
                        value: 'id',
                      }" :rules="[rules.required]" placeholder="Category" label="Category" filled color="accent"
                      size="large" @change="changeCategory">
                    </TreeSelect>
                  </v-col>
                  <v-col>
                    <v-autocomplete color="accent" label="Brand" v-model="product.Brand" type="text" :items="brands"
                      :rules="[rules.required]" :item-text="'name'" :item-value="'id'" outlined dense clearable
                      return-object multiple @change="ChangeBrand">
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-autocomplete color="accent" label="Gender" v-model="product.Gender" type="text" :items="genders"
                      :rules="[rules.required]" :item-text="'name'" :item-value="'id'" outlined dense clearable
                      return-object>
                    </v-autocomplete>
                  </v-col>
                  <v-col>
                    <v-autocomplete color="accent" label="Season" v-model="product.Season" type="text" :items="seasons"
                      :item-text="'name'" :item-value="'id'" outlined dense clearable return-object>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-autocomplete color="accent" label="Product Type" v-model="product.ProductType" type="text"
                      :items="productsType" :rules="[rules.required]" :item-text="'name'" :item-value="'id'" outlined
                      dense clearable return-object @change="ChangeProductType">
                    </v-autocomplete>
                  </v-col>
                  <v-col>
                    <v-autocomplete color="accent" label="Product unit" v-model="product.productUnit" type="text"
                      :items="units" :rules="[rules.required]" :item-text="'name'" :item-value="'id'" outlined dense
                      clearable return-object>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field color="accent" label="Bar Code" v-model="product.BarCode" type="text" outlined dense
                      clearable :rules="[rules.required]" @wheel="$event.target.blur()">
                    </v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field color="accent" :label="product.productUnit == 'Kg'
                      ? 'Min order (Kg)'
                      : 'Min order (Pieces)'
                      " v-model="product.MinOrder" type="number" outlined dense min="1" clearable
                      :rules="[rules.required, rules.Price]" @wheel="$event.target.blur()">
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-checkbox v-model="product.UpdateQuantity" :label="`Update quantity `"
                      @change="checkQuantityUpdate"></v-checkbox>
                  </v-col>
                </v-row>
                <v-row v-if="product.UpdateQuantity">
                  <v-col>
                    <h4>
                      In order to update the quantity please put the Location of
                      the quantity and the new quantity
                    </h4>
                  </v-col>
                </v-row>
                <div v-else></div>
                <v-row v-if="product.UpdateQuantity">
                  <v-col>
                    <v-text-field color="accent" label="Location" v-model="product.NewLocation" type="text" outlined
                      dense clearable :rules="[rules.required]" @wheel="$event.target.blur()">
                    </v-text-field>
                  </v-col>

                  <v-col>
                    <v-text-field color="accent" label="Quantity" v-model="product.NewQuantity" type="number" outlined
                      dense min="1" clearable :rules="[rules.required]" @wheel="$event.target.blur()">
                    </v-text-field>
                  </v-col>
                </v-row>
                <div v-else></div>
                <v-row>
                  <v-col>
                    <v-text-field color="accent" label="Price" v-model="product.Price" type="number" outlined dense
                      min="1" clearable :rules="[rules.required, rules.Price]" @wheel="$event.target.blur()">
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field color="accent" label="Gross Weight (KG)" v-model="product.GrossWeight" type="number"
                      outlined dense clearable :rules="[rules.required]" @wheel="$event.target.blur()">
                    </v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field color="accent" label="Net Weight (KG)" v-model="product.NetWeight" type="number"
                      outlined dense clearable :rules="[rules.required]" @wheel="$event.target.blur()">
                    </v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field color="accent" label="Length (cm)" v-model="product.Length" type="number" outlined
                      dense clearable :rules="[rules.required]" @wheel="$event.target.blur()">
                    </v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field color="accent" label="Height (cm)" v-model="product.Height" type="number" outlined
                      dense clearable :rules="[rules.required]" @wheel="$event.target.blur()">
                    </v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field color="accent" label="Width (cm)" v-model="product.Width" type="number" outlined dense
                      clearable :rules="[rules.required]" @wheel="$event.target.blur()">
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <div v-if="SizeLine" class="margin">
                      <v-expansion-panels>
                        <v-expansion-panel>
                          <v-expansion-panel-header>Variations</v-expansion-panel-header>
                          <v-expansion-panel-content v-if="product.ProductType == 'Size Line'">
                            <div v-for="(item, i) in product.Variations" :key="i" class="borderd">
                              <v-row>
                                <v-col>
                                  <v-autocomplete color="accent" label="Color" v-model="product.Variations[i].color"
                                    type="text" :items="colors" :rules="[rules.required]" :item-text="'name'"
                                    :item-value="'name'" outlined dense clearable>
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="1" class="mt-1">
                                  <v-icon class="ml-4" size="30" color="error" cursor="pointer"
                                    @click="removeField(i, 'variation')">mdi-close-thick</v-icon>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col v-for="(conf, k) in sizeconfiguration" :key="k">
                                  <v-text-field v-if="sizeconfiguration[k].type == 'string'" color="accent"
                                    :label="sizeconfiguration[k].title" v-model="product.Variations[i].sizes[
                                      sizeconfiguration[k].title
                                    ]
                                      " type="text" outlined dense clearable :rules="[rules.required]"
                                    @wheel="$event.target.blur()" />

                                  <v-autocomplete v-if="sizeconfiguration[k].type == 'select'" color="accent"
                                    :label="sizeconfiguration[k].title" v-model="product.Variations[i].sizes[
                                      sizeconfiguration[k].title
                                    ]
                                      " type="text" :items="sizeconfiguration[k].values" :rules="[rules.required]"
                                    :item-text="'name'" :item-value="'id'" outlined dense clearable>
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col>
                                  <v-text-field color="accent" label="Min Quantity"
                                    v-model="product.Variations[i].minQuantity" type="number" outlined dense clearable
                                    :rules="[rules.required]" @wheel="$event.target.blur()">
                                  </v-text-field>
                                </v-col>
                                <v-col>
                                  <v-text-field color="accent" label="Max Quantity"
                                    v-model="product.Variations[i].maxQuantity" type="number" outlined dense clearable
                                    :rules="[rules.required]" @wheel="$event.target.blur()">
                                  </v-text-field>
                                </v-col>
                              </v-row>
                            </div>
                            <v-btn @click="addItem">Add Variation</v-btn>
                          </v-expansion-panel-content>

                          <v-expansion-panel-content v-if="
                            product.ProductType == 'WH MIX' ||
                            product.ProductType == 'WH CR'
                          ">
                            <div v-for="(item, i) in product.Variations" :key="i" class="borderd">
                              <v-row>
                                <v-col>
                                  <VTreeselect v-model="product.Variations[i].item" :multiple="false"
                                    :options="variationCategory" @input="
                                      ($event) => changeVariation($event, i)
                                    " placeholder="item" search-nested :showCount="true" />
                                </v-col>

                                <v-col cols="1" class="mt-1">
                                  <v-icon class="ml-4" size="30" color="error" cursor="pointer"
                                    @click="removeField(i, 'variation')">mdi-close-thick</v-icon>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col v-for="(conf, k) in product.Variations[i]
                                  .configuration" :key="k">
                                  <v-text-field v-if="conf.type == 'string'" color="accent" :label="conf.title" v-model="product.Variations[i].sizes[conf.title]
                                    " type="text" outlined dense clearable :rules="[rules.required]"
                                    @wheel="$event.target.blur()" />

                                  <v-autocomplete v-if="conf.type == 'select'" color="accent" :label="conf.title"
                                    v-model="product.Variations[i].sizes[conf.title]
                                      " type="text" :items="conf.values" :rules="[rules.required]" :item-text="'name'"
                                    :item-value="'id'" outlined dense clearable>
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col>
                                  <v-text-field color="accent" label="Min Quantity"
                                    v-model="product.Variations[i].minQuantity" type="number" outlined dense clearable
                                    :rules="[rules.required]" @wheel="$event.target.blur()">
                                  </v-text-field>
                                </v-col>
                                <v-col>
                                  <v-text-field color="accent" label="Max Quantity"
                                    v-model="product.Variations[i].maxQuantity" type="number" outlined dense clearable
                                    :rules="[rules.required]" @wheel="$event.target.blur()">
                                  </v-text-field>
                                </v-col>
                              </v-row>
                            </div>
                            <v-btn @click="addItem">Add Variation</v-btn>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <h4>Description</h4>
                    <VueEditor v-model="product.Description"></VueEditor>
                  </v-col>
                </v-row>

                <v-divider class="my-15 divider"></v-divider>

                <v-row>
                  <v-col>
                    <h4>Featured image</h4>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-file-input v-model="product.FeaturedImageFile" placeholder="Upload photo..."
                      prepend-icon="mdi-paperclip" outlined color="accent" :rules="[]"
                      accept="image/png, image/jpeg, image/jpg" dense chips small-chips @change="validateFeatured">
                    </v-file-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-img v-if="product.FeaturedImage" :src="product.FeaturedImage" contain height="200"></v-img>
                </v-row>
                <v-divider class="my-15 divider"></v-divider>
                <v-row>
                  <v-col>
                    <h4>Images</h4>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-file-input v-model="files" placeholder="Upload photos..." multiple prepend-icon="mdi-paperclip"
                      outlined color="accent" :rules="[]" accept="image/png, image/jpeg, image/jpg" dense chips
                      small-chips @change="validateFiles">
                    </v-file-input>
                  </v-col>
                </v-row>
                <v-divider class="my-15 divider"></v-divider>

                <v-row class="mt-4">
                  <v-col cols="2" v-for="(photo, i) in product.Images" :key="i" class=".item row">
                    <v-card class="ma-1 pa-0 col">
                      <v-card-text class="ma-0 pa-0">
                        <expandable-image :src="photo"> </expandable-image>
                      </v-card-text>
                      <v-card-actions class="pa-0 ma-0">
                        <v-btn :key="item" text fab @click="deletePhoto(photo, i)">
                          <v-icon color="red">mdi-delete</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>

                <v-divider class="my-15 divider"></v-divider>

                <v-row>
                  <v-col>
                    <h4>Product video</h4>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-file-input v-model="product.VideoFile" placeholder="Upload video..." prepend-icon="mdi-paperclip"
                      outlined color="accent" :rules="[]" accept="video/mp4,video/x-m4v,video/*" dense chips small-chips
                      @change="validateVideo">
                    </v-file-input>
                  </v-col>
                </v-row>
                <v-row v-if="product.Video">
                  <video ref="video" width="400" controls>
                    <source :src="product.Video" />
                    Your browser does not support HTML video.
                  </video>
                </v-row>
                <v-row>
                  <v-col>
                    <h4>
                      To use the meta title generated by YOAST SEO leave the
                      meta title input empty
                    </h4>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field color="accent" label="Meta title" v-model="product.MetaTitle" type="text" outlined
                      dense clearable @wheel="$event.target.blur()">
                    </v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field color="accent" label="focus keyphrase" v-model="product.Keyphrase" type="text"
                      outlined dense clearable @wheel="$event.target.blur()">
                    </v-text-field>
                  </v-col>
                </v-row>
                <div v-if="hiddenDiv"></div>
                <v-row>
                  <v-col>
                    <v-textarea outlined name="input-7-4" label="Meta description" v-model="product.MetaDescription"
                      @wheel="$event.target.blur()"></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDialog">
                Close
              </v-btn>
              <v-btn color="blue darken-1" text @click="UpdateProduct">
                Update
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
    <v-dialog v-model="UpdateTitle" v-show="showUpdateTitle" @click:outside="UpdateTitle == true" persistent
      max-width="600px">
      <v-card>
        <v-form ref="formUpdate" lazy-validation @input="formToggled">
          <v-card-title class="subtitle-1 grey accent" primary-title>
            <span class="text-h5">Review new product</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <v-text-field color="accent" label="Title" v-model="product.Title" type="text" outlined dense
                    clearable :rules="[rules.required]" @wheel="$event.target.blur()">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="2">
                  <h3 class="text-grey">SKU :</h3>
                </v-col>
                <v-col>
                  <h4>{{ product.SKU }}</h4>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="ShowPrintModal">
              print SKU
            </v-btn>
            <v-btn color="blue darken-1" text @click="saveTitle"> Save </v-btn>
          </v-card-actions>
        </v-form></v-card>
    </v-dialog>
    <v-dialog persistent v-model="PrintSKU" width="650px">
      <v-card>
        <v-form ref="form" lazy-validation @input="formToggled">
          <v-card-title class="subtitle-1 grey accent" primary-title>
            <span class="text-h5">Print the SKU</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-spacer></v-spacer>
              <v-row><v-col></v-col></v-row>
              <v-row>
                <h3>
                  How many time you want to print this SKU {{ currentSKU }}
                </h3>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field color="accent" label="" v-model="PrintNumber" type="number" outlined dense clearable
                    :rules="[rules.required, rules.prices]" @wheel="$event.target.blur()">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDialog">
              Close
            </v-btn>
            <v-btn color="blue darken-1" text @click="PrintTheSKU">
              Print
            </v-btn>
          </v-card-actions>
        </v-form></v-card>
    </v-dialog>
    <v-dialog persistent v-model="statusDialog" width="unset">
      <status-info :responseMessage="responseMessage" :filename="filename" :pending="pending" @close="closeStatusDialog"
        @showProductInfo="postSearch(product.SKU)" :textColor="textColor" :showCheckBtn="showCheckBtn"></status-info>
    </v-dialog>
    <v-snackbar top v-model="snackbar" color="#FF3232" class="white--text">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import StatusInfo from "../organisms/StatusInfo";
import { TreeSelect } from "ant-design-vue";
import { VueEditor } from "vue2-editor";
import axios from "axios";
import { printerSKU } from "../../modules/print";
import VTreeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  name: "update-wh-product",
  props: { close: Function, oldProduct: Object, formatFilterValues: Function },
  components: {
    StatusInfo,
    TreeSelect,
    VueEditor,
    VTreeselect,
  },
  data: () => ({
    dialog: false,
    showDialog: false,
    statusDialog: true,
    pending: true,
    filename: "",
    showCheckBtn: false,
    textColor: "",
    responseMessage: "",
    categories: [],
    brands: [],
    seasons: [],
    productsType: [],
    genders: [],
    colors: [],
    SizeLine: false,
    units: ["Pieces", "Kg"],
    // ✅ Initialize product with safe defaults instead of null
    // fetchDropDowns will overwrite this with real data
    product: {
      Title: "",
      Brand: [],
      Gender: null,
      Season: null,
      ProductType: null,
      productUnit: null,
      BarCode: "",
      MinOrder: null,
      Price: null,
      GrossWeight: null,
      NetWeight: null,
      Length: null,
      Height: null,
      Width: null,
      CategoryId: null,
      Variations: [],
      Images: [],
      files: [],
      UpdateQuantity: false,
      Description: "",
      MetaTitle: "",
      MetaDescription: "",
      Keyphrase: "",
      FeaturedImage: null,
      Video: null,
    },
    rules: {
      required: (value) => !!value || "Field is required.",
      Price: (value) => value > 0 || "Must be more than 0",
      requiredQuantity: (value) => {
        if (this.product.UpdateQuantity && !!value) {
          return !!value || "Field is required.";
        }
      },
    },
    snackbarText: "",
    snackbar: false,
    newProduct: {},
    UpdateTitle: false,
    showUpdateTitle: false,
    files: [],
    PrintNumber: 1,
    PrintSKU: false,
    currentSKU: "",
    sizeconfiguration: [],
    variationCategory: [],
    hiddenDiv: false,
  }),
  async mounted() {
    this.statusDialog = true;
    this.pending = true;
    await this.fetchDropDowns();
    // ✅ Original line — just guarded so empty ERP products don't crash
    if (this.product.CategoryId) {
      this.findConfig(this.categories, this.product.CategoryId);
    }
    this.product.UpdateQuantity = false;
  },
  methods: {
    ChangeBrand(value) {
      console.log(JSON.stringify(value));
      if (this.product.ProductType != "Size Line") {
        this.product.Brand = [value[value.length - 1]];
      }
    },
    checkQuantityUpdate() {
      this.SizeLine = !this.SizeLine;
      this.SizeLine = !this.SizeLine;
    },
    async ShowPrintModal() {
      this.PrintSKU = true;
      this.currentSKU = this.product.SKU;
      this.UpdateTitle = false;
    },
    changeCategory(data) {
      console.log(data);
      console.log(this.categories);
      this.findConfig(this.categories, data);
      console.log(this.sizeconfiguration);
    },
    findConfig(data, id) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].id == id) {
          var configuration = data[i].configuration.map((c) => {
            if (c.type == "select") {
              c.values = c.values.map((v) => {
                return { name: v, id: v };
              });
            }
            return c;
          });
          this.sizeconfiguration = configuration;
          return;
        } else if (data[i].children.length) {
          this.findConfig(data[i].children, id);
        } else {
          continue;
        }
      }
    },
    findVariationCat(data, id, index) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].id == id) {
          // ✅ Guard: only map if configuration exists
          var config = (data[i].configuration || []).map((c) => {
            if (c.type == "select") {
              c.values = c.values.map((v) => {
                return { name: v, id: v };
              });
            }
            return c;
          });
          this.product.Variations[index].configuration = config;
          this.product.Variations[index].name = data[i].label;
          return;
        } else if (data[i].children && data[i].children.length) {  // ✅ also guard .children
          this.findVariationCat(data[i].children, id, index);
        } else {
          continue;
        }
      }
    },
    changeVariation(event, index) {
      // ✅ Don't toggle SizeLine — it unmounts the treeselect mid-input event
      // Just update the configuration directly
      if (event) {
        this.findVariationCat(this.variationCategory, event, index);
      }
    },
    removeField(index, type) {
      if (type == "location") {
        this.product.Locations.splice(index, 1);
      }
      if (type == "variation") {
        this.SizeLine = false;
        this.product.Variations.splice(index, 1);
        this.SizeLine = true;
      }
    },
    addItem() {
      this.SizeLine = false;
      if (this.product.ProductType == "Size Line") {
        this.product.Variations.push({
          color: null,
          sizes: {},
          minQuantity: null,
          maxQuantity: null,
        });
      }
      if (
        this.product.ProductType == "WH MIX" ||
        this.product.ProductType == "WH CR"
      ) {
        this.product.Variations.push({
          item: null,
          sizes: {},
          minQuantity: null,
          maxQuantity: null,
          configuration: [],
        });
      }

      this.SizeLine = true;
    },
    ChangeProductType(data) {
      console.log(data);
      this.SizeLine = false;
      if (data == "Size Line") {
        this.SizeLine = true;
        this.product.Variations = [
          { color: null, sizes: {}, minQuantity: null, maxQuantity: null },
        ];
      } else if (data == "WH MIX" || data == "WH CR") {
        this.SizeLine = true;
        this.product.Variations = [
          {
            item: null,
            sizes: {},
            minQuantity: null,
            maxQuantity: null,
            configuration: [],
          },
        ];
      } else {
        this.SizeLine = false;
        delete this.product.Variations;
      }
    },
    PrintTheSKU() {
      printerSKU(this.PrintNumber, this.currentSKU);
      this.PrintSKU = false;
    },
    async fetchDropDowns() {
      const response = await this.$store.dispatch("getDropdownsWholeSales");
      this.categories = response.data.categories;
      this.variationCategory = response.data.variationCategories;
      this.brands = response.data.brands;
      this.seasons = response.data.seasons;
      this.productsType = response.data.productsType;
      this.genders = response.data.genders;
      this.colors = response.data.colors;
      this.pending = false;
      this.statusDialog = false;
      this.showDialog = true;
      this.dialog = true;

      // ✅ Merge defaults UNDER oldProduct — existing fields are never overwritten
      this.product = {
        Title: "",
        Brand: [],
        Gender: null,
        Season: null,
        ProductType: null,
        productUnit: null,
        BarCode: "",
        MinOrder: null,
        Price: null,
        GrossWeight: null,
        NetWeight: null,
        Length: null,
        Height: null,
        Width: null,
        CategoryId: null,
        Variations: [],
        Images: [],
        files: [],
        UpdateQuantity: false,
        Description: "",
        MetaTitle: "",
        MetaDescription: "",
        Keyphrase: "",
        FeaturedImage: null,
        Video: null,
        ...this.oldProduct, // ✅ real product fields always win
      };

      // ✅ Original logic preserved exactly — only runs when Gender is a string (normal products)
      // ERP products have Gender: null so this block is safely skipped
      if (typeof this.product.Gender === "string") {
        var Gender = this.genders.find((g) => g.name == this.product.Gender);
        this.product.Gender = Gender;
      }

      // ✅ Same for Season
      if (typeof this.product.Season === "string") {
        var Season = this.seasons.find((s) => s.name == this.product.Season);
        this.product.Season = Season ? Season : null;
      }

      // ✅ Original Brand logic preserved — only runs when Brand is a string (normal products)
      // ERP products have Brand: [] so this block is safely skipped
      if (typeof this.product.Brand === "string") {
        this.product.Brand.split(","); // original line preserved
        var brandName = this.brands.filter((b) =>
          this.product.Brand.includes(b.name)
        );
        this.product.Brand = brandName;
      }

      this.product.files = [];

      // ✅ Original Variations logic preserved
      if (this.product.Variations && this.product.Variations.length > 0) {
        this.SizeLine = true;
      } else {
        this.SizeLine = false;
      }
    },
    closeDialog() {
      this.close();
      this.dialog = false;
    },
    closeStatusDialog() {
      this.close();
      this.dialog = false;
    },
    formToggled() { },
    async UpdateProduct() {
      // ─── 1. Quantity update guard ─────────────────────────────────────────────
      if (
        this.product.UpdateQuantity &&
        (!this.product.NewLocation || !this.product.NewQuantity)
      ) {
        this.snackbarText = "The form is filled incorrectly!";
        this.snackbar = true;
        return;
      }

      // ─── 2. Variations validation ─────────────────────────────────────────────
      if (this.product.Variations && this.product.Variations.length > 0) {
        const hasError = this.product.Variations.some((item) => {
          if (this.product.ProductType === "Size Line") {
            return !item.color || !item.minQuantity || !item.maxQuantity;
          } else {
            // sizes only required when the category actually has config fields
            const hasConfig = item.configuration && item.configuration.length > 0;
            const sizesValid = !hasConfig || Object.keys(item.sizes || {}).length > 0;
            return !item.item || !sizesValid || !item.minQuantity || !item.maxQuantity;
          }
        });

        if (hasError) {
          this.snackbarText = "Please fix the variations!";
          this.snackbar = true;
          return;
        }
      }

      // ─── 3. Form & category validation ───────────────────────────────────────
      this.$refs.form.validate();

      if (!this.product.CategoryId) {
        this.snackbarText = "Please select a Category!";
        this.snackbar = true;
        return;
      }

      // ─── 4. Show pending state ────────────────────────────────────────────────
      this.pending = true;
      this.statusDialog = true;
      this.textColor = "basic--text";
      this.dialog = false;

      // ─── 5. Build FormData ────────────────────────────────────────────────────
      const formData = new FormData();

      if (this.product.files) {
        this.product.files.forEach((file) => formData.append("images", file));
      }
      if (this.product.FeaturedImageFile) {
        formData.append("featuredImage", this.product.FeaturedImageFile);
      }
      if (this.product.VideoFile) {
        formData.append("video", this.product.VideoFile);
      }

      formData.append("product", JSON.stringify(this.product));
      this.product = this.oldProduct;

      // ─── 6. Dispatch ──────────────────────────────────────────────────────────
      this.$store
        .dispatch("updateWHProduct", formData)
        .then((result) => {
          this.product = result.data;
          this.newProduct = result.data;
          this.pending = false;
          this.statusDialog = false;
          this.showUpdateTitle = true;
          this.UpdateTitle = true;
          this.formatFilterValues();
        })
        .catch((error) => {
          console.error("[UpdateProduct] dispatch error:", error);
          this.pending = false;
          this.statusDialog = true;
          this.filename = "server_down.svg";
          this.responseMessage =
            "Something went wrong in the update! Please contact your tech support!";
        });
    },
    deletePhoto(item, i) {
      //at first delete it in frontend
      this.hiddenDiv = !this.hiddenDiv;
      this.product["Images"].splice(i, 1);
      var pr = this.product.Images.filter((i) => i.includes("blob"));
      var index = pr.indexOf(item);
      this.product.files.splice(index, 1);
      //then delete it in the database
      if (!item.includes("blob")) {
        axios.post("api/WHProduct/deletePhoto", { photoLink: item });
      }
      this.hiddenDiv = !this.hiddenDiv;
    },
    validateFeatured(files) {
      let objectUrl = URL.createObjectURL(files);
      const img = new Image();
      img.onload = () => {
        if (!(img.width >= 500 || img.height >= 500)) {
          this.snackbarText = `${files.name} file dimensions are too small: ${img.width}x${img.height}. At least one dimension should be 500px.`;
          this.snackbar = true;
        }
      };
      img.src = objectUrl;
      this.product.FeaturedImage = objectUrl;
      this.product.FeaturedImageFile = files;
    },
    validateVideo(files) {
      let objectUrl = URL.createObjectURL(files);
      console.log(objectUrl);
      this.product.Video = objectUrl;
      this.$refs.video.load();
    },
    validateFiles(files) {
      for (const i in files) {
        let objectUrl = URL.createObjectURL(files[i]);
        const img = new Image();

        this.product.files.push(files[i]);

        if (!this.product.Images) {
          this.product.Images = [objectUrl];
        } else {
          this.product.Images.push(objectUrl);
        }
        img.onload = () => {
          if (!(img.width >= 500 || img.height >= 500)) {
            this.snackbarText = `${files[i].name} file dimensions are too small: ${img.width}x${img.height}. At least one dimension should be 500px.`;
            this.snackbar = true;
          }
        };
        img.src = objectUrl;
      }
    },
    async saveTitle() {
      if (this.$refs.formUpdate.validate()) {
        //show pending dialog
        this.pending = true;
        this.statusDialog = true;
        this.textColor = "basic--text";
        //stop showing product form dialog
        this.showUpdateTitle = false;
        this.UpdateTitle = false;
        // TODO create the function that will call the API !
        this.$store
          .dispatch("updateTitle", {
            id: this.product.id,
            Title: this.product.Title,
          })
          .then(() => {
            this.pending = false;
            this.statusDialog = true;
            this.responseMessage =
              "Product has been created ! SKU : " + this.product.SKU;
            this.filename = "high_five.svg";
          })
          .catch(() => {
            this.pending = false;
            this.statusDialog = true;
            this.filename = "server_down.svg";
            this.responseMessage = "Something went wrong! Please try again!";
          });
      } else {
        this.snackbarText = "The form is filled incorretly!";
        this.snackbar = true;
      }
    },
  },
};
</script>

<style>
.add_wh_pr_modal {
  background-color: #fff !important;
}

div#text {
  margin-top: 48px;
  text-align: center;
}

div#dropzone {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: visibility 175ms, opacity 175ms;
  display: table;
  text-shadow: 1px 1px 2px #000;
  color: #fff;
  background: rgba(0, 0, 0, 0.45);
  font: bold 42px Oswald, DejaVu Sans, Tahoma, sans-serif;
}

div#textnode {
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  transition: font-size 175ms;
}

.divider {
  margin: 0.75em !important;
}
</style>
